import React from 'react'
import s from './IconMarker.less'
import SVGIcon from '../../svg/SVGIcon'

export default function IconMarker({ icon, color, size, insideSvgSize }) {
  return (
    <div
      className={s.iconMarker}
      style={{
        background: color,
        width: size,
        height: size,
        borderRadius: size * 2
      }}
    >
      <div style={{ width: insideSvgSize, height: insideSvgSize }}>
        <SVGIcon icon={icon} />
      </div>
    </div>
  )
}
